import { _ as _baseIsMap } from './_baseIsMap.mjs';
import { _ as _baseUnary } from './_baseUnary.mjs';
import { _ as _nodeUtilExports } from './_nodeUtil.mjs';

var baseIsMap = _baseIsMap,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

var isMap_1 = isMap;

export { isMap_1 as i };
